/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { createTau } from '../../factoriesAny.js';
export var tauDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  createTau: createTau
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesTau.generated.js
// module id = 1532
// module chunks = 0